import { render, staticRenderFns } from "./jumpLink.vue?vue&type=template&id=572ede2e&scoped=true"
import script from "./jumpLink.vue?vue&type=script&lang=js"
export * from "./jumpLink.vue?vue&type=script&lang=js"
import style0 from "./jumpLink.vue?vue&type=style&index=0&id=572ede2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572ede2e",
  null
  
)

export default component.exports